import { captureException } from "@sentry/react"
import { useCallback } from "react"
import { useToast } from "@/components/ui/use-toast"
import { InvalidCredentialError } from "@/lib/errors"

export const useErrorHandler = (showToast = true) => {
  const toast = useToast()

  const handleError = useCallback(
    (error: unknown) => {
      captureException(error)

      if (!showToast) return

      if (error instanceof InvalidCredentialError) {
        toast.error({
          title: "ログインに失敗しました",
          description: "メールアドレスとパスワードを確かめてください",
        })
      } else {
        toast.error({
          title: "予期しないエラーが発生しました",
          description: "時間をおいて再度試してください",
        })
      }
    },
    [toast, showToast]
  )

  return { handleError } as const
}
